import { useNavigate } from "react-router-dom";

export function useBackButton(to?: string) {
  const navigate = useNavigate();

  function handleClick() {
    to ? navigate(to) : navigate(-1);
  }

  return { handleClick };
}
